/* tslint:disable */

import { FlowchartComponentDto } from './FlowchartComponentDto';
import { FlowchartElementType } from './FlowchartElementType';
import { GuidelineActionDto } from './GuidelineActionDto';
import { SelectionBehavior } from './SelectionBehavior';

export class FlowchartActionDto extends FlowchartComponentDto {
  guidelineActionId?: string | null;
  guidelineAction?: GuidelineActionDto;
  elementType?: FlowchartElementType;
  selectionBehaviorForChildren?: SelectionBehavior;
  selectionBehaviorForSiblings?: SelectionBehavior;
}
